import React from 'react'
import { AppButtonIcon } from '@components'
import { scraperSiteSelected } from 'Pages/Admin/GlobalExecution/@signals'

export default function actionsColumn() {
	return {
		name: 'idSite',
		label: ' ',
		options: {
			filter: false,
			sort: false,
			customBodyRowRender: (idSite, { name }) => (
				<AppButtonIcon
					icon="users"
					tooltip="View searches per user"
					onClick={() => { scraperSiteSelected.value = { idSite, name } }}
				/>
			),
		},
	}
}
